<app-filtro-select-busca
  [value]="value"
  [options]="opcoes"
  [placeholder]="carregando ? 'Carregando...' : placeholder"
  [placeholderBusca]="placeholderBusca"
  [disabled]="disabled || carregando"
  (valueChange)="onValueChange($event)"
></app-filtro-select-busca>
